
/**
* Licensed Materials - Property of IBM
* IBM Cognos Products: ba-dashboard-livewidget
* (C) Copyright IBM Corp. 2018, 2021
* US Government Users Restricted Rights - Use, duplication or disclosure restricted by GSA ADP Schedule Contract with IBM Corp.
*/
define({
	'dataSource': 'Adatforrás',
	'dataSourceId': 'Azonosító',
	'dataSourceType': 'Típus',
	'dataSourceName': 'Név',
	'dataSourcePath': 'Elérési út',
	'showInfoForAll': 'Az összes megjelenítés időtartamának megjelenítése',
	'hideInfoForAll': 'Az összes megjelenítés időtartamának elrejtése',
	'showPerformanceDetails': 'Az összes felületi elem újrafuttatása a teljesítményrészletek szerepeltetésével',
	'slotMappingField': 'Cella leképezések',
	'slotDataMapping': 'Leképezés',
	'slotID': 'ID',
	'slotCaption': 'Felirat',
	'slotMandatory': 'Kötelező',
	'slotIsMandatory': 'Igen',
	'slotIsNotMandatory': 'Nem',
	'infoNotAvailable': 'Nem érhető el',
	'performanceSection': 'Teljesítmény',
	'durationField': 'Időtartam',
	'singleQueryTime': 'Kiszolgáló lekérdezés (ezredmásodperc)',
	'multipleQueryTime': 'Kiszolgáló lekérdezés %{name} (ezredmásodperc)',
	'liveWidgetTotalTime': 'Összesen (ezredmásodperc)',
	'renderTimeNotAvailable': 'Nem használható',
	'renderInProgress': '(folyamatban)',
	'interactToTriggerQuery': 'Együttműködés a felületi elemmel egy lekérdezés elindítása érdekében',
	'fetchQuery': 'Lekérdezés lehívása',
	'showSQLMDX': 'SQL/MDX megjelenítése',
	'SQLMDX': 'SQL/MDX',
	'queryInfo': 'Lekérdezés adatai',
	'queryInfoNotAvailable': 'Nem állnak rendelkezésre lekérdezési információk',
	'query': 'Lekérdezés',
	'copy': 'Másolás',
	'close': 'Bezárás'
});
